import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { IconButton } from '@mui/material';
import { Settings } from '@mui/icons-material';
import { useOpenDeviceSettings } from 'features/device.settings.open/lib';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { preventDefault } from 'console/shared/hooks/utils';
export const useDeviceSettingsButton = (device_id) => {
    const [show_settings_dialog, onOpenDeviceSettings] = useOpenDeviceSettings(device_id);
    const is_staff = useAppSelector((state) => state.account.is_staff);
    const onOpenSettingsForStaff = useCallback((e) => {
        if (is_staff) {
            preventDefault(e);
            e.ctrlKey = true;
        }
        onOpenDeviceSettings(e);
    }, [onOpenDeviceSettings, is_staff]);
    const SettingsButton = useMemo(() => {
        const SettingsButtonComponent = ({ ...rest }) => {
            if (!show_settings_dialog) {
                return null;
            }
            return (_jsx(IconButton, { edge: "end", "aria-label": "open-device-settings", onClick: onOpenDeviceSettings, onContextMenu: onOpenSettingsForStaff, "data-tooltip": "device-settings-button", ...rest, children: _jsx(Settings, {}) }));
        };
        return SettingsButtonComponent;
    }, [show_settings_dialog, onOpenDeviceSettings, onOpenSettingsForStaff]);
    return SettingsButton;
};
